<ol class="breadcrumb-list flex flex-row grow items-center">
  @for (item of model(); track $index) {
    <li class="breadcrumb-item">
      @if (item.type === 'select') {
        @if (selectTemplate()) {
          <ng-template
            *ngTemplateOutlet="selectTemplate(); context: { $implicit: item }"
          ></ng-template>
        } @else {
          @if (item.selectConfig?.options?.length) {
            <p-select
              [options]="item.selectConfig.options"
              [filter]="true"
              [optionLabel]="item.selectConfig.optionLabel"
              [filterBy]="item.selectConfig.filterBy"
              (onChange)="item.selectConfig.onSelect($event)"
              [(ngModel)]="item.selectConfig.selectedOption"
              class="select-breadcrumb-item"
            >
              @if (item.selectConfig.selectedOption) {
                <ng-template pTemplate="selectedItem">
                  <div class="selected-option">
                    {{ item.selectConfig?.selectedOption.label }}
                  </div>
                </ng-template>
              }
              <ng-template
                let-option
                pTemplate="item"
              >
                <div class="option-item">
                  {{ option.label }}
                </div>
              </ng-template>
            </p-select>
          }
        }
      } @else {
        @if (item.routerLink) {
          <a
            [attr.data-testId]="'breadcrumb-' + item.label.toLowerCase().replace(' ', '-')"
            [target]="$safeNavigationMigration(item?.target)"
            [attr.title]="item?.label"
            [attr.tabindex]="item?.disabled ? null : '0'"
            [routerLink]="item.routerLink"
            [queryParams]="item.queryParams"
            [queryParamsHandling]="item.queryParamsHandling"
            [routerLinkActiveOptions]="item?.routerLinkActiveOptions || { exact: false }"
            class="breadcrumb-link"
            routerLinkActive="active"
          >
            @if (item.icon) {
              <i
                [class]="item.icon"
                class="breadcrumb-icon"
              ></i>
            }
            <span class="breadcrumb-label"> {{ item.label }}</span>
          </a>
        } @else {
          <a
            [target]="$safeNavigationMigration(item?.target)"
            [attr.title]="item?.title"
            [attr.tabindex]="item?.disabled ? null : '0'"
            (click)="onClick($event, item)"
            class="breadcrumb-link"
          >
            @if (item.icon) {
              <i
                [class]="item.icon"
                class="breadcrumb-icon"
              ></i>
            }
            <span class="breadcrumb-label"> {{ item.label }}</span>
          </a>
        }
      }
    </li>
    @if (!$last) {
      <li class="breadcrumb-separator">/</li>
    }
  }
</ol>
